import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { Button, Checkbox, Grid, Icon, Table } from 'semantic-ui-react'
import Section from '../UI/Section'
import ObjectivesIndicator from '../elements/ObjectivesIndicator'
import ConversationsModal from './ConversationsModal'
import { withoutDeleted } from './agentListHelpers'

const BotTable = ({
	botsList = [],
	title = '',
	isPremium = true,
	options = {},
	toggleCheckboxFilter,
	toggleAgentActiveState,
	detachAll,
	forcefullyLogoutAgent,
	deleteAgent,
	onConversationRemoved
}) => {

  const transformPersonalities = (personalitiesArray) => {
    if (!personalitiesArray || personalitiesArray.length === 0) {
      return ""
    }
    try {
      return JSON.parse(personalitiesArray)
        .sort()
        .join(', ')
        || ""
    } catch (error) {
      return personalitiesArray
	}
  }
  const [conversationsModal, setConversationsModal] = useState(null)

  const openConversationsPopup = async(agent) => {
    setConversationsModal({ agent })
  }

	return (
		<Section>
			<Grid columns={2}>
				<Grid.Column>
					<h2>{title}</h2>
				</Grid.Column>
				{isPremium && <Grid.Column className="right aligned">
          <Checkbox
						label="Show inactive bots"
						name="includeDeactivated"
						onChange={toggleCheckboxFilter}
						checked={options.includeDeactivated}/>
				</Grid.Column>}
			</Grid>
			<Table celled striped>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell>Name</Table.HeaderCell>
						<Table.HeaderCell>Personalities</Table.HeaderCell>
						{!isPremium && <Table.HeaderCell>Agent goals</Table.HeaderCell>}
						<Table.HeaderCell># Conversations</Table.HeaderCell>
						<Table.HeaderCell>Activate</Table.HeaderCell>
						<Table.HeaderCell>Actions</Table.HeaderCell>
					</Table.Row>
				</Table.Header>
					<Table.Body>

					{withoutDeleted(botsList)
						.sort((a, b) => b.createdAt - a.createdAt)
						.map((bot, i) => {
							return (
								<Table.Row key={i}>
									<Table.Cell>{bot.name}</Table.Cell>
									<Table.Cell>
                    {transformPersonalities(bot?.botPersonality)}
									</Table.Cell>
									{!isPremium && <Table.Cell>
										<ObjectivesIndicator
											agentObjectives={bot.objectives.map((o) => o.id)}
										/>
									</Table.Cell>}
									<Table.Cell onClick={() => openConversationsPopup(bot)}>
										{bot.conversationCount > 0 ? <a href="#">{bot.conversationCount}</a> : bot.conversationCount}
									</Table.Cell>
									<Table.Cell><Checkbox toggle checked={bot.isActive} onClick={() => toggleAgentActiveState?.(bot.id, !bot.isActive)}/></Table.Cell>
									<Table.Cell className='table-actions'>
										<NavLink style={{color: "#008AD5"}} to={`/admin/agents/edit/${bot.id}?retUrl=${location.pathname + location.search}`}><Icon name="pencil square" size='big'/></NavLink>
										{!!bot.conversationCount && <button title="Detach all conversations" onClick={() => detachAll?.(bot.id)}>
											<i className="big icons">
												<Icon className="blue" name="comment" size="small"/>
												<Icon className="red" name="ban" size="small"/>
											</i>
										</button>}
										{ bot.status !== 'offline' && <button title="Forcefully logout the agent" onClick={() => forcefullyLogoutAgent?.(bot.id)}>
											<i className="big icons">
												<Icon className="blue" name="sign out" size="small"/>
											</i>
										</button>}
										<Button icon compact color="red" onClick={() => deleteAgent?.(bot.id)}><Icon name="delete"/></Button>
									</Table.Cell>
								</Table.Row>
							)
						})
					}
					</Table.Body>
				</Table>
				{ conversationsModal && <ConversationsModal agent={conversationsModal.agent} onClose={() => setConversationsModal(null)} onConversationRemoved={onConversationRemoved}/>}
		</Section>
	)
}

export default BotTable
